/** Align with backend constants/permissions.js and mst_submodules.submodule_slug */
export const VISITOR_LIST_SUBMODULE_SLUG = "visitor-list";
export const VISITOR_REGISTER_SUBMODULE_SLUG = "visitor-register";
export const VISITOR_CONTROL_SUBMODULE_SLUG = "visitor-control";
